import React from 'react';
import $ from "jquery";
import { Dropdown, Grid, Checkbox, Input, Pagination } from 'semantic-ui-react';
import Title from '../../title';
import Loading from '../../loadings';
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import Model from './model';
import CustomerType from './CustomerType';
import Executive from './Executive';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddEditCustomer from './add';



class AddCustomer extends React.Component {

    state = {
        customers: [], taluk: [], district: [], state: [], customerType: [], model: [], executive: [], tableHeader: [],
        filterExecutive: '', filterTaluk: '', filterDistrict: '', filterModel: '', filterCustomerType: '', PageCount: 0,
        pageNo: 1, search: '', showEllipsis: true, showFirstAndLastNav: true, showPreviousAndNextNav: true, menuPermission:[], 
        filterState: '', status: [], filterStatus: '', discount: []
    }

    componentDidMount() {
        this.getPermission();
    } 

    getPermission() {
        let menuPermission = Permission('add-customer', this.props.menus);
        if (menuPermission.view) {
            this.getCustomer1();
            this.setColumnView();
        }
        this.setState({ menuPermission })
    }

    tableRows() {
        let rows = [];
        let customers = this.state.customers;
        customers.map((c) => {
            rows.push(
                {
                    name: <td>name</td>, 
                }
            );
        })
    }

    setColumnView() {
        let tableHeader = [
            {name: 'SI no', status: 1, column_name: 'sino'}, {name: 'Id', status: 1, column_name: 'id'}, 
            {name: 'Name', status: 1, column_name: 'name'},  {name: 'Taluk', status: 1, column_name: 'taluk'},
            {name: 'Mobile', status: 0, column_name: 'mobile'}, {name: 'Alt Mobile', status: 0, column_name: 'alt_mobile'}, 
            {name: 'WhatsApp Number', status: 0, column_name: 'whatsapp'}, {name: 'Mail', status: 0, column_name: 'email_id'}, 
            {name: 'Model', status: 0, column_name: 'model'}, {name: 'Customer Type', status: 1, column_name: 'type'}, 
            {name: 'Machine No', status: 0, column_name: 'machine_no'}, {name: 'Address', status: 0, column_name: 'address'}, 
            {name: 'District', status: 0, column_name: 'district'},  {name: 'State', status: 0, column_name: 'state'}, {name: 'Pincode', status: 0, column_name: 'pincode'}, 
            {name: 'Status', status: 0, column_name: 'status'}, {name: 'Created By', status: 0, column_name: 'created_by'}, 
            {name: 'Executive', status: 1, column_name: 'executive'}, {name: 'Machine No', status: 0, column_name: 'machine_no'}, 
            {name: 'TCS', status: 1, column_name: 'tcs'}, {name: 'Last Log', status: 1, column_name: 'lastused'}, 
            {name: 'Action', status: 1, column_name: 'action'} 
        ];
        this.getData(tableHeader);
    }

    handlePaginationChange = (e, { activePage }) => {
        this.getCustomer(activePage);
    }

    getCustomer1() {
        this.getCustomer(this.state.pageNo);
    }

    ExportData() {
        let { pageNo, filterExecutive, filterTaluk, filterDistrict, filterModel, filterCustomerType, search } = this.state;
        window.location = Server() + 'WebMaster/AddCustomer/export.php?search='+search+
                         '&pageNo='+pageNo+'&filterExecutive='+filterExecutive+
                         '&filterTaluk='+filterTaluk+
                         '&filterDistrict='+filterDistrict+
                         '&filterModel='+filterModel+
                         '&filterCustomerType='+filterCustomerType;
    }

    getCustomer(pageNo) {
        let context = this;
        let { filterExecutive, filterTaluk, filterDistrict, filterModel, filterCustomerType, search, filterState, filterStatus } = this.state;
        let data = { filterExecutive, filterTaluk, filterDistrict, filterModel, filterCustomerType, search, pageNo, filterState, filterStatus };
        context.setState({ load: true, message: 'Getting Customers!!!', pageNo })
        $.ajax({
            type: 'POST', data, url: Server() + 'WebMaster/AddCustomer/GetAllCustomer.php',
            success: function(customers) {
                let PageCount = 0;
                let allCustomers = [];
                try {
                    customers = JSON.parse(customers);
                    customers.map((v) => {
                        allCustomers = v.customer;
                        PageCount = v.PageCount;
                    })
                    let sino = pageNo - 1;
                    sino = sino * 100;
                    allCustomers.map((c) => { c.sino = ++sino; c.action = 'action'; })
                    context.setState({ customers: allCustomers, load: false, PageCount })
                } catch (e) {
                    console.log(e);
                }
            },
            error: function(e) {
                alert('Try again!!')
                context.setState({ load: false });
            }
        });
    }

    getData(tableHeader) {
        let context = this;
        context.setState({ load: true, message: 'Getting Customers!!!', tableHeader })
        $.ajax({
            type: 'POST', url: Server() + 'WebMaster/AddCustomer/GetCustomerFilterOption.php',
            success: function(data) {
            try {
                data = JSON.parse(data);
                let taluk = []; let district = []; 
                let state = []; let customerType = []; let model = []; 
                let executive = []; let allDatas = []; let status = [];
                let discount = [];
                data.map((c) => {
                    allDatas = c.AllDatas;
                }) 
                allDatas.map((c) => {
                    if (c.type == 'taluk') { taluk.push(c); } if (c.type == 'district') { district.push(c); }
                    if (c.type == 'state') { state.push(c); } if (c.type == 'customerType') { customerType.push(c); }
                    if (c.type == 'Model') { model.push(c); } if (c.type == 'Executive') { executive.push(c); }
                    if (c.type == 'discount') { discount.push(c); }
                    if (c.type == 'status') { status.push(c); }
                })
                context.setState({ taluk, district, state, customerType, model, executive, status, load: false, discount })
            } catch (e) {
                console.log(e);
            }
            },
            error: function(e) {
                alert('Try again!!')
                context.setState({ load: false });
            }
        });
    }

    makeDropDownValue(value) {
        let val = [{ key: '', text: '', value: '' }];
        value.map((c) => { if (c.name != '') { val.push({ key: c.name, text: c.name, value: c.id }) } })
        return val;
    }

    makeDropDownValue1(value) {
        let val = [{ key: '', text: '', value: '' }];
        value.map((c) => { if (c.name != '') { val.push({ key: c.name, text: c.name, value: c.name }) } })
        return val;
    }

    selectExecutive = (f, { value }) => { this.setState({ filterExecutive: value }) }

    selectTaluk = (f, { value }) => { this.setState({ filterTaluk: value }) }

    selectDistrict = (f, { value }) => { this.setState({ filterDistrict: value }) } 

    selectState = (f, { value }) => { this.setState({ filterState: value }) } 

    selectStatus = (f, { value }) => { this.setState({ filterStatus: value }) }

    selectModel = (f, { value }) => { this.setState({ filterModel: value }) } 

    selectCustomerType = (f, { value }) => { this.setState({ filterCustomerType: value }) }

    changeColumnStatus = (colmnName) => event => {
       let tableHeader = this.state.tableHeader;
       tableHeader.map((c) => {
           if (c.column_name == colmnName) {
               if (c.status == 1) { c.status = 0; }
               else { c.status = 1; }
           }
       })
       this.setState({ tableHeader })
    }
    
    render() {
        let { search, columnViewDialog, customers, taluk, district, state, customerType, status, discount, model, executive, tableHeader } = this.state;
        executive = this.makeDropDownValue(executive); taluk = this.makeDropDownValue1(taluk);
        district = this.makeDropDownValue1(district); state = this.makeDropDownValue1(state);
        customerType = this.makeDropDownValue(customerType); model = this.makeDropDownValue(model);
        status = this.makeDropDownValue1(status); discount=this.makeDropDownValue(discount);
        return (
            <div>
                <Loading load={this.state.load} message={this.state.message} />
                <Title title={'Add Customer'} openDrawer={this.props.openDrawer}/>
                { this.state.menuPermission.view ?
                <div>
                    <div style={{display: 'flex', width: '100%'}}>
                        <div style={{width: '15%', margin: '0.5%'}}>
                            <b>Search</b><br/>
                            <Input fluid focus placeholder='Search' value={search}
                                onChange={ event => { this.setState({ search: event.target.value }) } } />
                        </div>
                        <div style={{width: '15%', margin: '0.5%'}}>
                            <b>Executive</b><br/>
                            <Dropdown placeholder='Executive' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                search fluid selection onChange={this.selectExecutive}
                                options={executive} value={this.state.filterExecutive} />
                        </div>
                        <div style={{width: '15%', margin: '0.5%'}}>
                            <b>Customer Type</b><br/>
                            <Dropdown placeholder='Customer Type' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                search fluid selection onChange={this.selectCustomerType}
                                options={customerType} value={this.state.filterCustomerType} />
                        </div>
                        <div style={{width: '15%', margin: '0.5%'}}>
                            <b>Taluk</b><br/>
                            <Dropdown placeholder='Taluk' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                search fluid selection onChange={this.selectTaluk}
                                options={taluk} value={this.state.filterTaluk} />
                        </div>
                        <div style={{width: '15%', margin: '0.5%'}}>
                            <b>District</b><br/>
                            <Dropdown placeholder='District' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                search fluid selection onChange={this.selectDistrict}
                                options={district} value={this.state.filterDistrict} />
                        </div>
                        <div style={{width: '15%', margin: '0.5%'}}>
                            <b>State</b><br/>
                            <Dropdown placeholder='State' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                search fluid selection onChange={this.selectState}
                                options={state} value={this.state.filterState} />
                        </div>
                        <div style={{width: '15%', margin: '0.5%'}}>
                            <b>Model</b><br/>
                            <Dropdown placeholder='Model' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                search fluid selection onChange={this.selectModel}
                                options={model} value={this.state.filterModel} />
                        </div>
                        <div style={{width: '15%', margin: '0.5%'}}>
                            <b>Status</b><br/>
                            <Dropdown placeholder='Status' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                search fluid selection onChange={this.selectStatus}
                                options={status} value={this.state.filterStatus} />
                        </div>
                        <div style={{width: '10%', marginLeft: '1%', marginTop: '1%', marginRight: '1%'}}>
                            <br/>
                            <Button fullWidth variant="outlined" onClick={this.getCustomer1.bind(this)}>Search</Button>
                        </div>
                    </div>
                    <div style={{display: 'flex', marginBottom: '1%'}}>
                        <div style={{width: '7%', marginLeft: '1%', marginTop: '0.1%'}}>
                            <AddEditCustomer discount={discount} menuPermission={this.state.menuPermission} getCustomer={this.getCustomer1.bind(this)} taluk={taluk}  district={district} from="Add" model={model} state={state} customerType={customerType} />
                        </div>
                        <div style={{width: '10%', marginLeft: '1%', marginTop: '0.1%'}}>
                            <Button fullWidth variant="outlined" onClick={ () => { this.setState({ columnViewDialog: true }) } }>Column View</Button>
                        </div>
                        <div style={{width: '10%', marginLeft: '1%', marginTop: '0.1%'}}>
                            { this.state.menuPermission.exports ?
                                <Button fullWidth variant="outlined" onClick={this.ExportData.bind(this)}>Export</Button>:
                                null
                            }
                            
                        </div>
                    </div>
                    <div id="myDIV">
                    <table width="98%" id="table" style={{marginLeft: '1%', marginRight: '1%'}}>
                        <tr id="th">
                            { 
                                tableHeader.map((c) => {
                                    if (c.status == 1) {
                                        return (<th id="th">{c.name}</th>)
                                    }
                                })
                            }
                        </tr>
                        { 
                            customers.map((c) => {
                                return (
                                    <tr>
                                        {
                                            tableHeader.map((v) => {
                                                for (let [key, value] of Object.entries(c)) {
                                                    if (v.column_name == key && v.status == 1) {
                                                        if (key == 'action') {
                                                            return <td>
                                                                <AddEditCustomer discount={discount} 
                                                                    getCustomer={this.getCustomer1.bind(this)} 
                                                                    menuPermission={this.state.menuPermission} 
                                                                    update={ (customers) => { this.setState({ customers }) }} 
                                                                    customers={customers} from="Edit" item={c} 
                                                                    taluk={taluk}  district={district} model={model} 
                                                                    state={state} customerType={customerType} />
                                                            </td>
                                                        }
                                                        if (key == 'tcs') {
                                                            if (value == 0) {
                                                                return <td><center>{'No'}</center></td>
                                                            }
                                                            else {
                                                                return <td><center>{'Yes'}</center></td>
                                                            }
                                                        }
                                                        if (key == 'model') {
                                                            return <Model modelOption={model} model={c.model} />
                                                        }
                                                        if (key == 'type') {
                                                            return <CustomerType menuPermission={this.state.menuPermission} customerType={customerType} item={c} id={c.id} />
                                                        }
                                                        if (key == 'executive') {
                                                            return <Executive menuPermission={this.state.menuPermission} executive={executive} item={c} id={c.id} />
                                                        }
                                                        else {
                                                            return <td>{value}</td>
                                                        }
                                                    }
                                                }
                                            })
                                        }
                                    </tr>
                                )
                                
                            })
                        }
                    </table>

                    <div align="right">
                        <Pagination activePage={this.state.pageNo}
                        boundaryRange={1} onPageChange={this.handlePaginationChange}
                        siblingRange={1} totalPages={this.state.PageCount}
                        ellipsisItem={this.state.showEllipsis ? undefined : null}
                        prevItem={this.state.showPreviousAndNextNav ? undefined : null}
                        nextItem={this.state.showPreviousAndNextNav ? undefined : null}
                        />
                    </div>
                    </div>
                    <Dialog fullWidth={true} maxWidth={'lg'} open={columnViewDialog} aria-labelledby="responsive-dialog-title">
                        <DialogTitle id="responsive-dialog-title" id="widthdialog">{"Column View"}</DialogTitle>
                        <DialogContent>
                            <Grid>
                                { 
                                    tableHeader.map((c) => {
                                        return (
                                            <Grid.Column mobile={3} computer={3} tablet={3}>
                                                <Checkbox onChange={this.changeColumnStatus(c.column_name)} label={c.name} 
                                                defaultChecked={c.status} />
                                            </Grid.Column>
                                        )
                                    })
                                }
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={ () => { this.setState({ columnViewDialog: false }) }} variant="outlined" 
                            color="secondary">Close</Button>
                        </DialogActions>
                    </Dialog>
                </div>:
                <center>You Are Not Allow To Access This Menu!!!</center>
                }
            </div>
        );
    }
}

export default AddCustomer;
